const images = {
	logo: require('../assets/images/Logo.svg').default,
};

export default images;
